using "./dom";
using "./velement";

// Kopular's structural-directive equivalents — see the README's
// "Structural directives" section for the full *ngIf/*ngFor/*ngSwitch
// mapping. There's no template language here (Kopular doesn't have one, by
// design — see component.ks), so these are just plain functions: call them
// like any other expression from inside Render(), the same way you'd call
// VElement.Create.
//
// *ngFor and *ngSwitch need nothing new — `array.ForEach(...)` and
// KopScript's own `match` expression already cover them (and `match` is
// exhaustiveness-checked, which *ngSwitch isn't). `If` below is the one
// piece the language doesn't already give you as an expression: `if` is a
// statement in KopScript, so without this you'd need a throwaway mutable
// local to get a conditional value.

// The *ngIf equivalent — conditionally build one of two subtrees, as an
// expression. Both branches are required: v1 has no nullable types, so
// "render nothing" has no value to return — the same reasoning Router uses
// for requiring a NotFoundPage up front (see router.ks) rather than letting
// "no match" be null. Only the branch actually taken runs; the other
// lambda is never called, so an explicit empty branch (e.g.
// `() => VElement.Create("span")`) costs nothing when there's genuinely
// nothing to show.
VElement If(bool condition, () => VElement whenTrue, () => VElement whenFalse) {
  if (condition) {
    return whenTrue();
  }
  return whenFalse();
}
